import { render, staticRenderFns } from "./OptionsConfigurator.vue?vue&type=template&id=a8d4d33a&"
import script from "./OptionsConfigurator.vue?vue&type=script&lang=js&"
export * from "./OptionsConfigurator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports